export const typoThin = {
  fontFamily: "'Segoe UI', sans-serif",
  fontSize: "13px",
  fontWeight: 400,
};

export const typoBase = {
  fontFamily: "'Segoe UI', sans-serif",
  fontSize: "14px",
  fontWeight: 400,
};

export const typoMedium = {
  fontFamily: "'Segoe UI', sans-serif",
  fontSize: "14px",
  fontWeight: 500,
};

export const xlBold = {
  fontFamily: "'Segoe UI', sans-serif",
  fontSize: "24px",
  fontWeight: 700,
};

export const largeBold = {
    fontFamily: "'Segoe UI', sans-serif",
    fontSize: "20px",
    fontWeight: 600,
  };

export const mediumBold = {
    fontFamily: "'Segoe UI', sans-serif",
    fontSize: "16px",
    fontWeight: 600,
    };

export const smallBold = {
  fontFamily: "'Segoe UI', sans-serif",
  fontSize: "14px",
  fontWeight: 600,
};

export const thinBold = {
    fontFamily: "'Segoe UI', sans-serif",
    fontSize: "13px",
    fontWeight: 500,
  };

export const largeTitle = {
  fontFamily: "'Segoe UI', sans-serif",
  fontSize: "24px",
  fontWeight: 600,
};

export const mediumTitle = {
    fontFamily: "'Segoe UI', sans-serif",
    fontSize: "18px",
    fontWeight: 500,
  };

export const smallTitle = {
  fontFamily: "'Segoe UI', sans-serif",
  fontSize: "16px",
  fontWeight: 500,
};

export const thinTitle = {
  fontFamily: "'Segoe UI', sans-serif",
  fontSize: "16px",
  fontWeight: 400,
};
